import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.choicesInstances = []

    this.selectTargets.forEach((select) => {
      const choices = new Choices(select, {
        removeItemButton: true,
        duplicateItemsAllowed: false,
        shouldSort: true,
        searchResultLimit: -1,
        fuseOptions: {
          threshold: 0.3,
          minMatchCharLength: 1
        }
      })

      this.choicesInstances.push(choices)
    })
  }

  disconnect() {
    this.choicesInstances.forEach(choices => {
      if (choices) {
        choices.destroy()
      }
    })
  }
}
